module.exports = __webpack_public_path__ + "static/media/COSTILLASAL_MENU-normal.0f7755e0.png";